"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { cn } from "@repo/design-system/utils/cn";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { type ReactNode, useState } from "react";
import { useMediaQuery } from "usehooks-ts";
import { useLanguage } from "~/translations/loader/use-language";
function Step(t0) {
  const $ = _c(8);
  const {
    children,
    side,
    index,
    length,
    bubbleStyle,
    boxStyle,
    setActiveIndex
  } = t0;
  let t1;
  if ($[0] !== boxStyle || $[1] !== bubbleStyle || $[2] !== children || $[3] !== index || $[4] !== length || $[5] !== setActiveIndex || $[6] !== side) {
    t1 = side === "left" ? <button className="absolute flex translate-x-4 -translate-y-1/2 text-end lg:right-1/2 lg:translate-x-6 [&_*]:transition-all [&_*]:duration-300" onClick={() => setActiveIndex(index)} style={{
      top: `${index * (100 / (length - 1))}%`
    }} type="button"><div className={cn("mr-4 rounded-md bg-gray-200 p-3 lg:p-4", boxStyle)} data-source="lc">{children}</div><div className={cn("relative my-auto flex aspect-square h-8 w-8 items-center justify-center rounded-full lg:h-12 lg:w-12", bubbleStyle)}>{index + 1}</div></button> : <button className="absolute flex -translate-x-4 -translate-y-1/2 lg:left-1/2 lg:-translate-x-6 [&_*]:transition-all [&_*]:duration-300 [&_*]:ease-in-out" onClick={() => setActiveIndex(index)} style={{
      top: `${index * (100 / (length - 1))}%`
    }} type="button"><div className={cn("relative my-auto flex aspect-square h-8 w-8 items-center justify-center rounded-full lg:h-12 lg:w-12", bubbleStyle)}>{index + 1}</div><div className={cn("ml-4 rounded-md bg-gray-200 p-3 lg:p-4", boxStyle)} data-source="lc">{children}</div></button>;
    $[0] = boxStyle;
    $[1] = bubbleStyle;
    $[2] = children;
    $[3] = index;
    $[4] = length;
    $[5] = setActiveIndex;
    $[6] = side;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
export default function ApplicationProcessEonSverige() {
  const $ = _c(90);
  const t = useLanguage();
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const [activeIndex, setActiveIndex] = useState(0);
  let t0;
  if ($[0] !== t.sverige_application_advertisement || $[1] !== t.sverige_application_advertisement_text) {
    t0 = {
      title: t.sverige_application_advertisement,
      text: t.sverige_application_advertisement_text,
      icon: "annons.svg"
    };
    $[0] = t.sverige_application_advertisement;
    $[1] = t.sverige_application_advertisement_text;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.sverige_application_application || $[4] !== t.sverige_application_application_text) {
    t1 = {
      title: t.sverige_application_application,
      text: t.sverige_application_application_text,
      icon: "ans\xF6kan.svg"
    };
    $[3] = t.sverige_application_application;
    $[4] = t.sverige_application_application_text;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t.sverige_application_selection || $[7] !== t.sverige_application_selection_text) {
    t2 = {
      title: t.sverige_application_selection,
      text: t.sverige_application_selection_text,
      icon: "urval.svg"
    };
    $[6] = t.sverige_application_selection;
    $[7] = t.sverige_application_selection_text;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t.sverige_application_telephoneInterview || $[10] !== t.sverige_application_telephoneInterview_text) {
    t3 = {
      title: t.sverige_application_telephoneInterview,
      text: t.sverige_application_telephoneInterview_text,
      icon: "telefon-intervju.svg"
    };
    $[9] = t.sverige_application_telephoneInterview;
    $[10] = t.sverige_application_telephoneInterview_text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t.sverige_application_personalInterview || $[13] !== t.sverige_application_personalInterview_text) {
    t4 = {
      title: t.sverige_application_personalInterview,
      text: t.sverige_application_personalInterview_text,
      icon: "personlig-intervju.svg"
    };
    $[12] = t.sverige_application_personalInterview;
    $[13] = t.sverige_application_personalInterview_text;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t.sverige_application_tests || $[16] !== t.sverige_application_tests_text) {
    t5 = {
      title: t.sverige_application_tests,
      text: t.sverige_application_tests_text,
      icon: "tester-och-referenser.svg"
    };
    $[15] = t.sverige_application_tests;
    $[16] = t.sverige_application_tests_text;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t.sverige_application_finalInterview || $[19] !== t.sverige_application_finalInterview_text) {
    t6 = {
      title: t.sverige_application_finalInterview,
      text: t.sverige_application_finalInterview_text,
      icon: "slut-intervju.svg"
    };
    $[18] = t.sverige_application_finalInterview;
    $[19] = t.sverige_application_finalInterview_text;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t.sverige_application_offer || $[22] !== t.sverige_application_offer_text) {
    t7 = {
      title: t.sverige_application_offer,
      text: t.sverige_application_offer_text,
      icon: "erbjudande ob jobb.svg"
    };
    $[21] = t.sverige_application_offer;
    $[22] = t.sverige_application_offer_text;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t.sverige_application_onboarding || $[25] !== t.sverige_application_onboarding_text) {
    t8 = {
      title: t.sverige_application_onboarding,
      text: t.sverige_application_onboarding_text,
      icon: "onboarding.svg"
    };
    $[24] = t.sverige_application_onboarding;
    $[25] = t.sverige_application_onboarding_text;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CustomImage alt="" className="object-contain" height={50} src="images/icons/sverige/e.on.svg" width={50} />;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t.sverige_application_welcome_text) {
    t10 = {
      title: t9,
      text: t.sverige_application_welcome_text
    };
    $[28] = t.sverige_application_welcome_text;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t0 || $[31] !== t1 || $[32] !== t10 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8) {
    t11 = [t0, t1, t2, t3, t4, t5, t6, t7, t8, t10];
    $[30] = t0;
    $[31] = t1;
    $[32] = t10;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t5;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const steps = t11;
  const calculateHeight = 64 * (steps.length - 1);
  let t12;
  if ($[41] !== isMobile) {
    t12 = function getSide(index) {
      if (isMobile) {
        return "right";
      }
      return index % 2 === 0 ? "left" : "right";
    };
    $[41] = isMobile;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const getSide = t12;
  let t13;
  if ($[43] !== t.jobad_process_hl) {
    t13 = <h2 className="mb-8 font-bold text-3xl text-foreground md:text-4xl lg:mb-24 lg:text-5xl" data-source="lc">{t.jobad_process_hl}</h2>;
    $[43] = t.jobad_process_hl;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="absolute top-0 bottom-0 -z-10 w-1 -translate-x-1/2 bg-secondary lg:left-1/2" />;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== calculateHeight) {
    t15 = {
      height: calculateHeight
    };
    $[46] = calculateHeight;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== activeIndex || $[49] !== getSide || $[50] !== steps) {
    t16 = steps.map((step, index_0) => <Step boxStyle={cn(index_0 === activeIndex ? "bg-primary text-headline_font_color" : "bg-secondary", index_0 === steps.length - 1 && "mt-4")} bubbleStyle={cn(index_0 === activeIndex ? "scale-110 bg-primary text-headline_font_color" : "bg-secondary")} index={index_0} key={index_0} length={steps.length} setActiveIndex={setActiveIndex} side={getSide(index_0)}><div className="flex h-full items-center justify-center gap-x-4 [&_img]:h-14 lg:[&_img]:h-auto">{step.title}</div></Step>);
    $[48] = activeIndex;
    $[49] = getSide;
    $[50] = steps;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== t15 || $[53] !== t16) {
    t17 = <div className="relative my-6 ml-4 w-full md:my-10 md:ml-0">{t14}<div className="w-full" style={t15}>{t16}</div></div>;
    $[52] = t15;
    $[53] = t16;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== activeIndex || $[56] !== steps) {
    t18 = steps[activeIndex].icon && <CustomImage alt="" className="h-12 w-12 object-contain" height={50} src={`images/icons/sverige/${steps[activeIndex].icon}`} width={50} />;
    $[55] = activeIndex;
    $[56] = steps;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  const t19 = steps[activeIndex];
  let t20;
  if ($[58] !== t19.title) {
    t20 = <span data-source="lc">{t19.title}</span>;
    $[58] = t19.title;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t18 || $[61] !== t20) {
    t21 = <div className="mb-6 flex items-end gap-x-4 text-xl lg:text-2xl">{t18}{t20}</div>;
    $[60] = t18;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  const t22 = steps[activeIndex];
  let t23;
  if ($[63] !== t22.text) {
    t23 = <div data-source="lc">{t22.text}</div>;
    $[63] = t22.text;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== t21 || $[66] !== t23) {
    t24 = <div>{t21}{t23}</div>;
    $[65] = t21;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  const t25 = activeIndex === 0;
  let t26;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setActiveIndex(_temp);
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <ChevronLeft size={32} />;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== t25) {
    t28 = <button className="absolute top-1/2 left-0 h-full -translate-y-1/2 disabled:opacity-30" disabled={t25} onClick={t26} type="button">{t27}</button>;
    $[70] = t25;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  const t29 = activeIndex === steps.length - 1;
  let t30;
  if ($[72] !== steps.length) {
    t30 = () => setActiveIndex(prev_0 => Math.min(steps.length - 1, prev_0 + 1));
    $[72] = steps.length;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <ChevronRight size={32} />;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t29 || $[76] !== t30) {
    t32 = <button className="absolute top-1/2 right-0 h-full -translate-y-1/2 disabled:opacity-30" disabled={t29} onClick={t30} type="button">{t31}</button>;
    $[75] = t29;
    $[76] = t30;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== t28 || $[79] !== t32) {
    t33 = <div>{t28}{t32}</div>;
    $[78] = t28;
    $[79] = t32;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== t24 || $[82] !== t33) {
    t34 = <div className="flex h-[332px] xs:h-72 sm:h-auto"><div className="relative my-auto w-full rounded-md bg-primary p-8 text-lg lg:text-xl">{t24}{t33}</div></div>;
    $[81] = t24;
    $[82] = t33;
    $[83] = t34;
  } else {
    t34 = $[83];
  }
  let t35;
  if ($[84] !== t17 || $[85] !== t34) {
    t35 = <div className="grid auto-cols-fr gap-10 sm:grid-flow-col lg:gap-12">{t17}{t34}</div>;
    $[84] = t17;
    $[85] = t34;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t13 || $[88] !== t35) {
    t36 = <section className="outer-container overflow-hidden py-container text-white text-xl" id="applicationProcess"><div className="inner-container">{t13}{t35}</div></section>;
    $[87] = t13;
    $[88] = t35;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  return t36;
}
function _temp(prev) {
  return Math.max(0, prev - 1);
}